module.exports = __webpack_public_path__ + "img/14-silo-front.555a184b.png";